<div *ngIf="toastState.open" class="gl-notifications__container">
  <div class="gl-notifications">
    <div class="gl-notifications__item">
      <div class="gl-notifications__item--close" (click)="onClose()">
        <span class="glicon-close"></span>
      </div>
      <div>
        <div class="gl-notifications__item--title">
          <span *ngIf="toastState.icon" [ngClass]="toastState.icon"></span>
          <span *ngIf="toastState.title" [innerHTML]="toastState.title"></span>
        </div>
        <div
          *ngIf="toastState.text || toastState.html"
          class="gl-notifications__item--message"
          [innerHTML]="toastState.text || toastState.html"
        ></div>
      </div>
      <div class="gl-notifications__item--link">
        <a (click)="toastService.confirmPopup()" target="_blank" class="gl-notifications__item--link__success">
          {{ toastState.actionButtonText }}</a
        >
      </div>
    </div>
  </div>
</div>
